export type CoachTheme = "light" | "dark";

export const COACH_THEME_STORAGE_KEY = "arc-coach-theme";
export const COACH_THEME_EXPLICIT_STORAGE_KEY = "arc-coach-theme-explicit";

type ReadableThemeStorage = Pick<Storage, "getItem">;
type WritableThemeStorage = Pick<Storage, "setItem">;

function readStorageValue(storage: ReadableThemeStorage | null | undefined, key: string): string | null {
  try {
    return storage?.getItem(key) ?? null;
  } catch {
    return null;
  }
}

export function readCoachThemePreference(
  storage: ReadableThemeStorage | null | undefined,
): CoachTheme {
  const storedTheme = readStorageValue(storage, COACH_THEME_STORAGE_KEY);
  const hasExplicitChoice = readStorageValue(storage, COACH_THEME_EXPLICIT_STORAGE_KEY) === "1";

  if (storedTheme === "light" && hasExplicitChoice) return "light";
  return "dark";
}

export function persistCoachThemePreference(
  storage: WritableThemeStorage | null | undefined,
  theme: CoachTheme,
): void {
  try {
    storage?.setItem(COACH_THEME_STORAGE_KEY, theme);
    storage?.setItem(COACH_THEME_EXPLICIT_STORAGE_KEY, "1");
  } catch {
    // localStorage can be unavailable in embedded/private contexts.
  }
}
